import React, { useEffect, useState } from 'react';
import { TextField, Button, Grid, Typography, makeStyles, Container, Box, CircularProgress, MenuItem, Divider } from '@material-ui/core';
import Layout from '../Layout';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import CustomBreadcrumbs from '../Breadcrumb';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AssetTable from '../AssetTransfer/AssetTable';
import { AssetDisposaluploadFile, getDisposalDOA, getUsersforDOA, postDisposalReq } from '../../ReduxStore/AssetDisposalSlice';
import Select from 'react-select';
const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(4),
        maxWidth: 800,
        margin: '0 auto',
        paddingBlock: 10,
        marginTop: 5,
        marginBottom: 5
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
    },
    formControl: {
        // marginBottom: theme.spacing(2),
    },
    button: {
        // marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
}));



const headers = [
    "Asset Code/No",
    "Asset Description",
    "Asset Type",
    "PO No.",
    "PO Line Item No.",
    "PO Line Item Description",
    "Asset Type Selection",
    "Present Location",
    "Name of Vendor",
    "Vendor Code",
    "Year of Purchase/Installation",
    "Name of Manufacturer",
    "Business Unit",
    "BusA Description",
    "Country of Origin",
    "Manufacturer Serial Number",
    "Model/ Project of Asset",
    "Number of Loose Parts/Aggregates",
    "Quantity",
    "Weight of Asset(in kg)",
    "Overall Size of Asset(H x W x L)",
    "Performance expected to be achieved by the Asset",
    "Performance achieved by the Asset",
    "Major defects in the Asset",
    "Condition of the Asset",
    "Are any parts missing",
    "Original asset value",
    "Present written down value",
    // "GST%",
    // "SGST%",
    // "IGST%",
    // "HSN Code",
    // "EPCG Obligations",
    // "No.of Pending Years"
];

// const header2 = [
//     "Asset Code / No.",
//     "Asset Description",
//     "Asset Type",
//     "PO No.",
//     "PO Line Item No.",
//     "PO Line Item Description",
//     "Performance expected to be achieved by the Asset",
//     "Performance achieved by the Asset",
//     "Major defects in the assets",
//     "Condition of the assets",
//     "Are any parts missing?",
// ];

const AssetDisposalRequest = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const classes = useStyles();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' }
    ];

    // const [plant_code, setPlant_code] = useState("");
    const [loading, setLoading] = useState(true);
    const [BCNo, setBCNo] = useState("");
    const [disposalType, setDisposalType] = useState("");
    const [division, setDivision] = useState("");
    // const [raiser_name, setRaiserName] = useState();
    const [techSpec, setTechspec] = useState();
    const [addDetails, setAddDetails] = useState();
    const [postLoading, setPostLoading] = useState(false);
    const [DOA, setDOA] = useState([]);
    const [filteredDOA, setFilteredDOA] = useState([]);
    const [users, setUsers] = useState([]);
    const [userOptions, setUserOptions] = useState([]);
    const [uploading, setUpLoading] = useState(false);
    const [raiser_dept, setRaiserdept] = useState("");
    // const [fileName, setFileName] = useState({
    //     filename: "",
    //     file: null
    // });
    const [fileData, setFileData] = useState({
        files: [],  // holds multiple files
    });
    const [finalRowsData, setFinalRowsData] = useState([]);
    // const [secRowsData, setSecRowsData] = useState([]);
    // const [header2Data, setHeader2Data] = useState([]);
    const [businessUnit, setBusinessUnit] = useState(null);

    const username = localStorage.getItem("username");

    const handleRowsChange = (rows) => {
        setFinalRowsData(rows);
        setBusinessUnit(rows[0]['Business Unit']);


        // Prefill the second table with relevant data from the first table
        // const mappedHeader2Data = rows.map(row => ({
        //     "Asset Code / No.": row["Asset Code/No"],
        //     "Asset Description": row["Asset Description"],
        //     "Asset Type": row["Asset Type"],
        //     "PO No.": row["PO No."],
        //     "PO Line Item No.": row["PO Line Item No."],
        //     "PO Line Item Description": row["PO Line Item Description"],
        //     "Performance expected to be achieved by the Asset": row["Performance expected to be achieved by the Asset"] || "",
        //     "Performance achieved by the Asset": row["Performance achieved by the Asset"] || "",
        //     "Major defects in the assets": row["Major defects in the Asset"] || "",
        //     "Condition of the assets": row["Condition of the Asset"] || "",
        //     "Are any parts missing?": row["Are any parts missing"] || "",

        // }));
        // setHeader2Data(mappedHeader2Data);
    };

    // const handleSecondRowChange = (rows) => {
    //     // Update the state in the parent whenever rows change
    //     setSecRowsData(rows);
    // };
    const [selectedUsers, setSelectedUsers] = useState([]);
    const handleUserChange = (selectedOption, index) => {
        const updatedUsers = [...selectedUsers];
        updatedUsers[index] = {
            id: DOA[index].id,
            levelname: DOA[index].levelname,
            level_sequence: DOA[index].level_sequence,
            user_id: selectedOption ? selectedOption.value : null,
            user_name: selectedOption ? selectedOption.label : null,
            department: DOA[index].department,
            plant_code: DOA[index].plant_code,
        };
        console.log("check", updatedUsers)
        setSelectedUsers(updatedUsers);
    };



    const handleFileChange = (event) => {
        const allowedExtensions = ["msg", "pdf", "ppt", "pptx", "jpeg", "jpg", "png", "xls", "xlsx", "doc", "docx", "txt"];

        const selectedFiles = Array.from(event.target.files); // Convert FileList to an array

        const validatedFiles = selectedFiles.filter((file) => {

            const fileName = file.name;
            // Validate for double extensions
            const fileParts = fileName.split('.');
            if (fileParts.length !== 2) {
                toast.info('Invalid file name. Ensure it has only one valid extension.');
                return false;
            }

            const fileExtension = file.name.split('.').pop().toLowerCase();
            if (!allowedExtensions.includes(fileExtension)) {
                toast.info(`File "${file.name}" has an invalid extension.`);
                return false;
            }
            if (file.name.startsWith('.')) {
                toast.info(`File "${file.name}" is not allowed.`);
                return false;
            }
            return true;
        });

        // Merge existing files with newly selected files
        setFileData((prevState) => ({
            files: [...prevState.files, ...validatedFiles],
        }));
    };

    // const AssetDisposalUpload = async (log_id, hid) => {
    //     const formData = new FormData();
    //     formData.append(fileName.filename, fileName.file);
    //     formData.append('hid', hid);
    //     formData.append('disposal_logs_id', log_id);
    //     formData.append('file_description', 'Raised');
    //     try {
    //         setUpLoading(true)
    //         const action = dispatch(AssetDisposaluploadFile(formData));
    //         const res = await action.unwrap();
    //         console.log("res from pv log:", res);
    //         if (res.StatusCode === 200) {
    //             setUpLoading(false)
    //             console.log("check upload file", res.response)
    //             // setshowUploadedImage(true);
    //             toast.success("Image Upload Done");
    //             // setUploadedImgUrl(res.response.s3_file_url);
    //             // setFileName(res.response.file_name);
    //             // console.log("imageURL", uploadedImgUrl, fileName)
    //         } else {
    //             toast.error("Something went wrong!")
    //         }
    //     } catch (error) {
    //         console.error("Error in okHandler:", error);
    //         toast.error(error.message || "Something went wrong!");
    //     } finally {
    //         setUpLoading(false)
    //     }
    // }

    const AssetDisposalUpload = async (log_id, hid) => {
        try {
            setUpLoading(true);
            // Loop through each selected file
            for (const file of fileData.files) {
                const formData = new FormData();
                formData.append(file.name, file);  // Add the file
                // formData.append('filename', file.name);
                formData.append('hid', hid);
                formData.append('disposal_logs_id', log_id);
                formData.append('file_description', 'Raised');

                // Dispatch the action to upload each file
                const action = dispatch(AssetDisposaluploadFile(formData));
                const res = await action.unwrap();
                console.log("res from pv log:", res);

                if (res.StatusCode === 200) {
                    toast.success(`${file.name} Upload Done`);
                } else {
                    toast.error(`Something went wrong with ${file.name}!`);
                }
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        } finally {
            setUpLoading(false);
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            raiser_name: username,
            raiser_dept: raiser_dept,
            disposal_type: disposalType,
            division: division,
            bc_no: BCNo,
            tech_details: techSpec || "",
            additional_details: addDetails || "",
            asset_details: finalRowsData.map(row => ({
                asset_no: row["Asset Code/No"] || "",
                description: row["Asset Description"] || "",
                business_area: row["Business Unit"] || "",
                other_details: {
                    "Asset Type": row["Asset Type"] || "",
                    "PO No": row["PO No."] || "",
                    "PO Line Item No": row["PO Line Item No."] || "",
                    "PO Line Item Description": row["PO Line Item Description"] || "",
                    "Present Location": row["Present Location"] || "",
                    "Name of Vendor": row["Name of Vendor"] || "",
                    "Vendor Code": row["Vendor Code"] || "",
                    "Year of Purchase/Installation": row["Year of Purchase/Installation"] || "",
                    "Name of Manufacturer": row["Name of Manufacturer"] || "",
                    "Country of Origin": row["Country of Origin"] || "",
                    "Manufacturer Serial Number": row["Manufacturer Serial Number"] || "",
                    "Model/ Project of Asset": row["Model/ Project of Asset"] || "",
                    "Number of Loose Parts/Aggregates": row["Number of Loose Parts/Aggregates"] || "",
                    "Quantity": row["Quantity"] || "",
                    "Weight of Asset(in kg)": row["Weight of Asset(in kg)"] || "",
                    "Overall Size of Asset(H x W x L)": row["Overall Size of Asset(H x W x L)"] || "",

                    "Performance expected to be achieved by the Asset": row["Performance expected to be achieved by the Asset"] || "",
                    "Performance achieved by the Asset": row["Performance achieved by the Asset"] || "",
                    "Major defects in the Asset": row["Major defects in the Asset"] || "",
                    "Condition of the Asset": row["Condition of the Asset"] || "",
                    "Are any parts missing": row["Are any parts missing"] || "",

                    "Original asset value": row["Original asset value"] || "",
                    "Present written down value": row["Present written down value"] || ""

                }

            })),
            doa: selectedUsers.map(DOA => ({
                id: DOA.id,
                levelname: DOA.levelname,
                level_sequence: DOA.level_sequence,
                user_id: DOA.user_id,
                user_name: DOA.user_name,
                department: DOA.department,
                plant_code: DOA.plant_code,

            }))
        };

        console.log("check payload", payload);

        try {
            setPostLoading(true)
            const action = dispatch(postDisposalReq(payload));
            const res = await action.unwrap();
            console.log("res", res.result)
            if (res.StatusCode === 201) {
                if (fileData.files.length > 0) {
                    AssetDisposalUpload(res.result.id, res.result.hid);
                }
                setPostLoading(false)
                toast.success("Asset Disposal Requested!");
                // setTimeout(() => {
                //     navigate("/asset-disposal-table");
                // }, 2000);
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        } finally {
            setPostLoading(false)
        }
    };

    const getDOAs = async () => {
        try {
            const action = dispatch(getDisposalDOA());
            const res = await action.unwrap();
            console.log("DOA res", res.result)
            if (res.result) {
                setDOA(res.result)
            };
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "No Logs Found!");
        }
    }
    const getUserList = async () => {
        try {
            const action = dispatch(getUsersforDOA(`?customerID=af33f9117ecb4d8d8def84d6331eebd4`));
            const res = await action.unwrap();
            console.log("res", res)
            if (res.result) {
                setUsers(res.result)
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            await getDOAs();
            await getUserList();
            setLoading(false);
        };
        fetchData();
    }, [])

    useEffect(() => {
        if (users.length > 0) {
            const UserList = users && users.map(item => ({
                value: item.id,
                label: item.name,
            }));
            console.log("Assetlist", UserList);

            if (UserList) {
                setUserOptions(UserList.map(item => ({
                    value: item.value,
                    label: item.label,
                })));
            }
        }


    }, [users]);

    useEffect(() => {
        if (businessUnit) {
            const filteredDOA = DOA && DOA.filter(item => item.plant_code === businessUnit)
            setFilteredDOA(filteredDOA)
        }


    }, [DOA, businessUnit]);

    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h3" component="h1" gutterBottom>
                        Asset Disposal Request
                    </Typography>
                </Box> */}
                <Box mt={1} mb={3}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Asset Disposal Request" />
                </Box>
                <Box mb={2}>
                    <Grid container spacing={2}>
                        {/* <Grid item xs={12} sm={6}>
                                    <TextField label="Request Ref No." fullWidth variant="outlined" disabled />
                                </Grid> */}
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Proposer / Raiser Name"
                                fullWidth
                                variant="outlined"
                                value={username}
                                // onChange={(e) => setRaiserName(e.target.value)}
                                inputProps={{ readOnly: true }}
                            />
                        </Grid>
                        {/* <Grid item xs={12} sm={6}>
                                    <TextField
                                        className={classes.formControl}
                                        label="Raiser Department"
                                        name="RequestorDepartment"
                                        variant="outlined"
                                        value={raiser_dept}
                                        onChange={(e) => setRaiserdept(e.target.value)}
                                        fullWidth
                                    />
                                </Grid> */}
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Division"
                                fullWidth
                                variant="outlined"
                                select
                                value={division}
                                onChange={(e) => setDivision(e.target.value)}>
                                <MenuItem value="AQ P&SC">AQ P&SC</MenuItem>
                                <MenuItem value="CQ P&SC">CQ P&SC</MenuItem>
                                <MenuItem value="SC P&SC">SC P&SC</MenuItem>
                                <MenuItem value="Purchase P&SC">Purchase P&SC</MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Disposal Type"
                                fullWidth
                                variant="outlined"
                                select
                                value={disposalType}
                                onChange={(e) => setDisposalType(e.target.value)}
                            >
                                <MenuItem value="Normal">Normal</MenuItem>
                                <MenuItem value="Exceptional">Exceptional</MenuItem>
                            </TextField>
                        </Grid>
                        {/* <Grid item xs={12} sm={6}>
                                    <TextField label="Plant Code & Name" fullWidth variant="outlined" value={plant_code} onChange={(e) => setPlant_code(e.target.value)} />
                                </Grid> */}
                        <Grid item xs={12} sm={6}>
                            <TextField label="BC No" fullWidth variant="outlined" value={BCNo} onChange={(e) => setBCNo(e.target.value)} />
                        </Grid>
                    </Grid>
                </Box>
                <Box mb={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={2}>
                            <Typography variant="h6" gutterBottom>
                                Asset Details
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <AssetTable headers={headers} Width="4100" onRowsChange={handleRowsChange} />
                        </Grid>

                    </Grid>

                </Box>
                <Box mb={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={3}>
                            <Typography variant="h6" gutterBottom>
                                Technical Specifications
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                label="Detailed Tech Specification (Please attach details if required)"
                                fullWidth
                                variant="outlined"
                                value={techSpec}
                                onChange={(e) => setTechspec(e.target.value)}
                                multiline
                            />
                        </Grid>
                        {/* <Grid item xs={12}>
                            <TextField
                                label="Literature/Manuals/Drawings Available"
                                fullWidth
                                variant="outlined"
                                multiline
                                rows={2}
                            />
                        </Grid> */}
                    </Grid>

                </Box>
                {/* <Box mb={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={3}>
                            <Typography variant="h6" gutterBottom>
                                Present Condition of the Asset
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <AssetTable headers={header2} Width="2000" rowsData={header2Data} onRowsChange={handleSecondRowChange} />
                        </Grid>

                    </Grid>
                </Box> */}
                <Box mb={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <Typography variant="h6" gutterBottom>
                                Additional Details
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                className={classes.formControl}
                                label="Additional Details"
                                name="add-details"
                                variant="outlined"
                                value={addDetails}
                                onChange={(e) => setAddDetails(e.target.value)}
                                fullWidth
                                multiline
                                rows={4}
                            />
                        </Grid>
                    </Grid>
                </Box>
                {/* <Divider /> */}
                <Box mb={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={12}>
                            <Typography variant="h6" gutterBottom>
                                Attachments
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <input
                                type="file"
                                hidden id="fileInput"
                                multiple
                                accept=".msg, .pdf, .ppt, .pptx, .jpeg, .jpg, .png, .xls, .xlsx, .doc, .docx, .txt"
                                onChange={handleFileChange} />
                            <label htmlFor="fileInput">
                                <Button variant="contained" component="span" color="primary">
                                    Select File
                                </Button>
                            </label>
                            <Typography
                                variant="body2"
                                color="textSecondary"
                                style={{ marginTop: 8 }}
                            >
                                Note - multiple attachments can be done with size limit of 5 MB each, mail message, pdf, ppt, jpeg, XLS, XLSX, word, text files can be attached
                            </Typography>
                            {fileData.files.length > 0 && (
                                <Typography variant="body1">
                                    Selected files: {fileData.files.map(file => file.name).join(', ')}
                                </Typography>
                            )}
                            {/* {uploading && <Container>
                                <Box display="flex" justifyContent="center">
                                    File Uploading....
                                    <CircularProgress />
                                </Box>
                            </Container>} */}
                            {uploading && (
                                <Container>
                                    <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
                                        <Typography variant="body1" mr={2}>
                                            File Uploading...
                                        </Typography>
                                        <CircularProgress />
                                    </Box>
                                </Container>
                            )}
                        </Grid>
                    </Grid>
                </Box>

                {/* <Box mb={2}
                    border={1}
                    borderColor="grey.300"
                    borderRadius={4}
                    p={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={12}>
                            <Typography variant="h6" gutterBottom>
                                DOA
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} className="checkpoint-header" alignItems="center">
                        <Grid item xs={2}>
                            <h3>Level Seq.</h3>
                        </Grid>
                        <Grid item xs={2}>
                            <h3>Level Name</h3>
                        </Grid>
                        <Grid item xs={3}>
                            <h3>User Name</h3>
                        </Grid>
                        <Grid item xs={2}>
                            <h3>Department</h3>
                        </Grid>
                        <Grid item xs={2}>
                            <h3>Plant Code</h3>
                        </Grid>
                    </Grid>
                    <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                    {DOA && DOA.map((item, index) => {
                        return (
                            <React.Fragment key={index}>
                                <Grid
                                    container
                                    spacing={2}
                                    alignItems="center"
                                >
                                    <Grid item xs={2}>
                                        {item.level_sequence}
                                    </Grid>
                                    <Grid item xs={2}>
                                        {item.levelname}
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Select
                                            // styles={customStyles}
                                            options={userOptions}
                                            placeholder="Select User"
                                            isSearchable
                                            isClearable
                                        // value={row.asset}
                                        // onChange={(selectedOption) => handleAssetChange(selectedOption, index)}
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        {item.department}
                                    </Grid>
                                    <Grid item xs={2}>
                                        {item.plant_code}
                                    </Grid>
                                </Grid>
                                <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                            </React.Fragment>
                        );
                    })}
                </Box> */}
                {businessUnit && <Box
                    mb={2}
                    border={2}
                    borderColor="grey.300"
                    borderRadius={4}
                    p={2}
                    className="table-container"
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="h6" gutterBottom>
                                DOA
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid container spacing={3} className="checkpoint-header" alignItems="center" style={{ backgroundColor: '#f5f5f5', padding: '10px', borderRadius: '4px' }}>
                        <Grid item xs={2}>
                            <Typography variant="subtitle1" component="h3" style={{ fontWeight: 'bold' }}>
                                Level Seq.
                            </Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography variant="subtitle1" component="h3" style={{ fontWeight: 'bold' }}>
                                Level Name
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="subtitle1" component="h3" style={{ fontWeight: 'bold' }}>
                                Department
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="subtitle1" component="h3" style={{ fontWeight: 'bold' }}>
                                User Name
                            </Typography>
                        </Grid>
                    </Grid>

                    <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />

                    <Box className="table-content">
                        {filteredDOA && filteredDOA.map((item, index) => (
                            <React.Fragment key={index}>
                                <Grid container spacing={2} alignItems="center" style={{ padding: '10px 0' }}>
                                    <Grid item xs={2}>
                                        <Typography>{item.level_sequence}</Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Typography>{item.levelname}</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography>{item.department}</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Select
                                            options={userOptions}
                                            placeholder="Select User"
                                            isSearchable
                                            isClearable
                                            onChange={(selectedOption) => handleUserChange(selectedOption, index)}
                                        />
                                    </Grid>
                                </Grid>
                                <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                            </React.Fragment>
                        ))}
                    </Box>
                </Box>
                }

                <Grid container>
                    <Grid item xs={6} sm={2}>
                        <Button
                            className={classes.button}
                            type="submit"
                            style={{ backgroundColor: "green" }}
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                            fullWidth
                            startIcon={postLoading && <CircularProgress size={20} />}
                            disabled={postLoading}
                        >
                            {postLoading ? "Submitting" : "Submit"}
                        </Button>
                    </Grid>
                </Grid>
            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default AssetDisposalRequest;
